import { AgGridTable } from '@shared/components/ui/AgGridTable';
import { ColDef } from 'ag-grid-community';
import React from 'react';
import { CourierFilePayment } from '../../models';

interface CourierFilePaymentsAgGridTableProps {
    payments: CourierFilePayment[];
    columnDefs: ColDef[];
    isLoading?: boolean;
    isFetching?: boolean;
    sorting?: { field: string; direction: 'asc' | 'desc' } | null;
    onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
}

export const CourierFilePaymentsAgGridTable = React.memo(
    function CourierFilePaymentsAgGridTable({
        payments,
        columnDefs,
        isLoading = false,
        isFetching = false,
        sorting,
        onSortingChange,
    }: CourierFilePaymentsAgGridTableProps) {
        return (
            <div
                className={
                    isFetching
                        ? 'opacity-50 pointer-events-none transition-opacity duration-200'
                        : ''
                }
            >
                <AgGridTable
                    data={payments}
                    columnDefs={columnDefs}
                    height="calc(100vh - 200px)"
                    enableSelection={false}
                    isLoading={isLoading}
                    rowHeight={56}
                    sorting={sorting}
                    onSortingChange={onSortingChange}
                />
            </div>
        );
    }
);

